import { Button, Modal } from '@mui/material';
import React from 'react';
import { primaryColor, primaryColorBlue } from '../utility/constant';

const ForgetModel = ({ forget, setForget, forgetPassword, email }) => {
  return (
    <Modal open={forget} onClose={() => setForget(false)}>
      <div
        className="w-11/12 md:w-3/6 xl:w-2/6 bg-white rounded-2xl shadow-xl"
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          border: `1px solid ${primaryColorBlue}`,
        }}
      >
        {/* Header */}
        <div
          className="text-white font-medium py-3 px-4"
          style={{
            background: `linear-gradient(135deg, ${primaryColor} 40%, ${primaryColorBlue} 100%)`,
            borderTopLeftRadius: '1rem',
            borderTopRightRadius: '1rem',
          }}
        >
          Genius Office
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="flex items-center mb-4">
            <img
              src={require('../utility/images/ico.png')}
              className="mr-3 w-12 h-12"
              alt="reset"
            />
            <div>
              <p className="text-gray-700 text-sm mb-2">
                Click <span className="font-semibold">Continue</span> to reset
                your password.
              </p>
              <p className="text-gray-700 text-sm">
                Reset Password link has been sent on your email:
              </p>
              <p className="text-[15px] font-semibold text-gray-900">{email}</p>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-3 mt-6">
            <Button
              size="small"
              onClick={() => {
                forgetPassword(email);
                setForget(false);
              }}
              style={{
                backgroundColor: primaryColorBlue,
                textTransform: 'capitalize',
                fontSize: 14,
              }}
              variant="contained"
            >
              Continue
            </Button>

            <Button
              size="small"
              onClick={() => setForget(false)}
              style={{
                backgroundColor: primaryColor,
                textTransform: 'capitalize',
                fontSize: 14,
              }}
              variant="contained"
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ForgetModel;
